import { graphql } from '@predium/client-graphql';

export const ONGOING_EXPORTS_SUBSCRIPTION = graphql(`
  subscription OngoingExports($userId: Int!, $pendingJobIds: [Int!]!) {
    async_job(where: { user_id: { _eq: $userId }, id: { _in: $pendingJobIds } }, order_by: { created_at: desc }) {
      __typename
      id
      title
      description
      status_id
      created_at
      user_id
      org_id
      total_jobs_created
      total_jobs_finished
    }
  }
`);

export const USER_FILES_LIST = graphql(`
  query UserFilesList($userId: Int!) {
    file(where: { user_id: { _eq: $userId }, uploading: { _eq: false } }, order_by: { created_at: desc }) {
      __typename
      id
      name
      description
      created_at
    }
  }
`);

export const GET_FILE_DOWNLOAD_URL = graphql(`
  query GetFileDownloadUrl($fileId: Int!) {
    file_by_pk(id: $fileId) {
      __typename
      id
      name
      downloadUrl
    }
  }
`);

export const GET_FILE_PREVIEW = graphql(`
  query GetFilePreview($fileId: Int!) {
    getFilePreview(fileId: $fileId) {
      id
      name
      downloadUrl
    }
  }
`);

export const DELETE_USER_FILE = graphql(`
  mutation DeleteUserFile($fileId: Int!) {
    delete_file_by_pk(id: $fileId) {
      __typename
      id
    }
  }
`);

export const READ_NOTIFICATION = graphql(`
  mutation ReadNotifications($notificationIds: [Int!]!) {
    update_notification(where: { id: { _in: $notificationIds } }, _set: { read: true }) {
      returning {
        id
        __typename
        read
      }
    }
  }
`);

export const GET_FILE_ID_BY_ASYNC_JOB_ID = graphql(`
  query GetFileIdByAsyncJobId($asyncJobId: Int!) {
    async_job_by_pk(id: $asyncJobId) {
      id
      exportedFileId {
        fileId
      }
    }
  }
`);

/**
 * Presigned URL for a completed batch ESG-analysis PDF export zip. The zip lives
 * in the dedicated batch-export bucket (not the files bucket), so the generic
 * `file_by_pk.downloadUrl` path cannot resolve it — this backend query presigns
 * it directly, scoped to the caller's own job.
 */
export const GET_BATCH_ESG_ANALYSIS_PDF_EXPORT_DOWNLOAD_URL = graphql(`
  query GetBatchEsgAnalysisPdfExportDownloadUrl($asyncJobId: Int!) {
    getBatchEsgAnalysisPdfExportDownloadUrl(asyncJobId: $asyncJobId)
  }
`);

/**
 * The user's completed batch ESG-analysis PDF exports. Unlike regular exports these
 * are NOT in the `file` list (their zip lives in the batch-export bucket, and the
 * `file` row carries no user_id), so they are listed from their `async_job` rows and
 * re-downloaded via the dedicated presigned-URL query. The rows persist as long as
 * the zip does (90-day S3 retention), so the user can re-download within that window.
 */
export const COMPLETED_BATCH_EXPORTS = graphql(`
  query CompletedBatchExports($userId: Int!, $title: String!) {
    async_job(
      where: { user_id: { _eq: $userId }, title: { _eq: $title }, status_id: { _eq: COMPLETED } }
      order_by: { created_at: desc }
      limit: 25
    ) {
      __typename
      id
      title
      description
      created_at
    }
  }
`);
